module.exports = __webpack_public_path__ + "static/media/warriors.dc65e47e.png";